module.exports = __webpack_public_path__ + "img/footer-dva.8ff70c74.svg";